import React from 'react'

import { confirmSignIn, fetchAuthSession } from 'aws-amplify/auth'
import { useUpdatePasswordChangedAt } from 'src/features/auth/api'
import { usePostLoginNavigation } from 'src/legacy_modules/auth/login/hooks/usePostLoginNavigation'
import { login } from 'src/legacy_modules/auth/login/request'
import { useRequestState } from 'src/legacy_modules/server/use-request-state'

import {
  IProps as IRegisterPasswordProps,
  RegisterPassword,
} from './register-password'

export const RegisterPasswordContainer: React.FC<{}> = () => {
  const {
    requestDone,
    requestFailed,
    requestStarted,
    requesting,
    errorMessage,
  } = useRequestState()
  const { jumpAfterLogin } = usePostLoginNavigation()
  const { request: recordPasswordChange } = useUpdatePasswordChangedAt()

  const onSubmit: IRegisterPasswordProps['onSubmit'] = async ({
    password,
    passwordConfirmation,
  }) => {
    if (password !== passwordConfirmation) {
      requestFailed('パスワードが一致しません。')
      return
    }

    try {
      requestStarted()
      const {
        nextStep: { signInStep },
      } = await confirmSignIn({
        challengeResponse: password,
      })
      if (signInStep !== 'DONE') {
        requestFailed('パスワードの登録に失敗しました。')
        return
      }
      const session = await fetchAuthSession()
      const idToken = session.tokens?.idToken?.toString()
      if (!idToken) {
        requestFailed(
          'セッションの取得に失敗しました。時間を置いて再度お試し下さい。',
        )
        return
      }
      await login(idToken, true)
      await recordPasswordChange()
      await jumpAfterLogin()
    } catch (error) {
      // AWS Amplify v6ではerror.nameプロパティでエラーを判定する
      // Cognito APIで定義されているエラーコードを文字列リテラルで指定
      // (ライブラリの型定義が最新のCognito APIに追従していないため)
      switch (error.name) {
        case 'InvalidParameterException':
          requestFailed('適切な形式のパスワードを入力下さい。')
          break
        case 'InvalidPasswordException':
          requestFailed(`
            半角英字（大文字、小文字をそれぞれ1文字以上ずつ）含む、
            8文字以上の半角英数字記号を入力してください。
          `)
          break
        case 'LimitExceededException':
          requestFailed(
            'アカウントがロックされています。時間を置いて再度お試し下さい。',
          )
          break
        case 'PasswordHistoryPolicyViolationException':
          requestFailed(
            '過去に設定いただいているパスワードと同じ文字列はご利用できません。',
          )
          break
        default:
          // MiROHAのサーバーのエラーはこちらで受け取る
          if (error.message) {
            requestFailed(error.message)
            return
          }
          requestFailed('問題が発生しました。時間を置いて再度お試し下さい。')
      }
    } finally {
      requestDone()
    }
  }

  return (
    <RegisterPassword
      errorMessage={errorMessage}
      requesting={requesting}
      onSubmit={onSubmit}
    />
  )
}
